import React from 'react';
import { SmoothScroll } from './components/common/SmoothScroll';
import { CustomCursor } from './components/common/CustomCursor';
import { CraftInspector } from './components/common/CraftInspector';
import { ErrorBoundary } from './components/common/ErrorBoundary';
import { CSSNeuralPoster } from './components/canvas/CSSNeuralPoster';
import { NeuralCore3D } from './components/canvas/NeuralCore3D';

import { HeaderNav } from './components/sections/HeaderNav';
import { HeroSection } from './components/sections/HeroSection';
import { GroqProseReveal } from './components/sections/GroqProseReveal';
import { PinnedHorizontal } from './components/sections/PinnedHorizontal';
import { BentoArchitecture } from './components/sections/BentoArchitecture';
import { GroqSpeedPlayground } from './components/sections/GroqSpeedPlayground';
import { BenchmarkMatrix } from './components/sections/BenchmarkMatrix';
import { EditorialVoices } from './components/sections/EditorialVoices';
import { GrandFinale } from './components/sections/GrandFinale';
import { MinimalFooter } from './components/sections/MinimalFooter';
import { useAutoUpdate } from './hooks/useAutoUpdate';

export const App: React.FC = () => {
  // Automatically reload on smartphones and desktops when a new deployment is detected
  useAutoUpdate();

  return (
    <SmoothScroll>
      {/* Precision Inertial Cursor */}
      <CustomCursor />

      {/* 3D WebGL Neural Background Field (Fixed full-screen backdrop throughout page scroll) */}
      <ErrorBoundary fallback={<CSSNeuralPoster />}>
        <NeuralCore3D />
      </ErrorBoundary>

      {/* Hardware Film Grain Overlay (Desktop only to prevent mobile GPU shader stalls) */}
      <div
        className="hidden md:block film-grain-overlay pointer-events-none fixed inset-0 z-40 opacity-[0.035]"
        aria-hidden="true"
      />

      {/* Top Floating Pill Navigation */}
      <HeaderNav />

      {/* Main Exhibition Sequence */}
      <main className="relative z-10 w-full overflow-x-hidden bg-transparent">
        <HeroSection />
        <GroqProseReveal />
        <PinnedHorizontal />
        <BentoArchitecture />
        <GroqSpeedPlayground />
        <BenchmarkMatrix />
        <EditorialVoices />
        <GrandFinale />
      </main>

      {/* Swiss Minimalist Footer with World Clocks */}
      <MinimalFooter />

      {/* Live Craft Telemetry HUD */}
      <CraftInspector />
    </SmoothScroll>
  );
};

export default App;
